import { useEffect, useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhoWeAre from "@/components/site/WhoWeAre";
import WhyDubai from "@/components/site/WhyDubai";
import InvestmentPhilosophy from "@/components/site/InvestmentPhilosophy";
import FeaturedOpportunities from "@/components/site/FeaturedOpportunities";
import AdvisoryProcess from "@/components/site/AdvisoryProcess";
import WhyClientsTrust from "@/components/site/WhyClientsTrust";
import TrendingProjects from "@/components/site/TrendingProjects";
import MarketInsights from "@/components/site/MarketInsights";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Landing() {
  const [prefill, setPrefill] = useState("");

  useEffect(() => {
    document.title = "DXB Property Zone · Dubai Luxury Real Estate Investment Advisory";
  }, []);

  const handleRequestDetails = (property) => {
    // Works for both full Property and TrendingProject (Upcoming) shapes
    const developer = property.developer || property.agency || "";
    const price = property.starting_price || property.price_from || "";
    const plan = property.payment_plan || property.badge_label || "";
    const handover = property.completion || "";
    const location = property.location || "";
    const parts = [
      `I would like more details about ${property.name}`,
      developer ? `by ${developer}` : "",
      location ? `(${location})` : "",
      ".",
    ].filter(Boolean).join(" ");
    const details = [
      price ? `Starting price ${price}` : "",
      plan ? plan : "",
      handover ? `handover ${handover}` : "",
    ].filter(Boolean).join(", ");
    const msg = details
      ? `${parts} ${details}. Please share the full investment brief.`
      : `${parts} Please share the full investment brief.`;
    setPrefill(msg);
    setTimeout(() => {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  return (
    <div className="bg-[#FAFAF8] min-h-screen">
      <Navbar />
      <Hero />
      <WhoWeAre />
      <FeaturedOpportunities onRequestDetails={handleRequestDetails} />
      <WhyDubai />
      <InvestmentPhilosophy />
      <AdvisoryProcess />
      <WhyClientsTrust />
      <TrendingProjects onRequestDetails={handleRequestDetails} />
      <MarketInsights />
      <FinalCTA prefillMessage={prefill} />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
